import { render, staticRenderFns } from "./KitchenHandlesList.vue?vue&type=template&id=43bf68fb&"
import script from "./KitchenHandlesList.vue?vue&type=script&lang=js&"
export * from "./KitchenHandlesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports